import { Stack } from '@mui/material';
import { GroupedButtons } from '@uy3/web-components';
import { BankAccountApprovalType } from 'services/approvals/approvals';

type BankAccountApprovalsProps = {
    setApprovalType: React.Dispatch<React.SetStateAction<BankAccountApprovalType>>
}

export const BankAccountApprovals = ({ setApprovalType }: BankAccountApprovalsProps) => {
    
    const onClickSelectButton = (value: number) => {
        const getItemSelected: {[type: number]: string} = {
            0: "BankAccountUser", 
            1: "BankAccountTransfer", 
            2: "BankAccountPayment", 
            3: "BankAccountBeneficiary", 
            4: "BankAccountTransactionLimits"
        }

        setApprovalType(getItemSelected[value!] as BankAccountApprovalType); 
    }

    return (
        <Stack mb={3} mt={-2}>
            <GroupedButtons
                size="large"
                width={'100%'}
                onClick={onClickSelectButton}
                groupedButtons={[
                    'Operadores',
                    'Transferência',
                    'Pagamentos',
                    'Favorecidos',
                    'Limites'
                ]}
            />
        </Stack>
    );
};
